import React from "react";
import { EnrichedProgram } from "@/common/course/types";
import { FormatSubType } from "@/constants/tagular/main";
import NewProductCard from "./ProgramCard";
import { ProgramCard } from "@/components/ProgramCard";
import ProductCard from "@/components/ProductCard";
import { constructUrl } from "@/utils/functions/constructUrl";

type CardType = "product-card" | "program-card" | "new-product-card";

interface CardWrapperProps {
  item: EnrichedProgram;
  index: number;
  getUrl: (path?: string) => string | undefined;
  cardType?: CardType;
  className?: string;
  alignment?: "row" | "column";
  hasShadow?: boolean;
  skipViewEvent?: boolean;
  skipClickEvent?: boolean;
}

function CardWrapper({
  item,
  index,
  getUrl,
  alignment = "column",
  cardType = "product-card",
  className = "",
  hasShadow = true,
  skipViewEvent = false,
  skipClickEvent = false,
}: CardWrapperProps) {
  const renderCard = () => {
    if (cardType === "program-card") {
      const { pricingData: { originalPrice, discountedPrice } = {} } = item;

      const total = discountedPrice ?? originalPrice;
      const priceWithoutDiscount = discountedPrice ? originalPrice : undefined;
      return (
        <ProgramCard
          childCoursesCount={item.courses?.length}
          hasShadow={hasShadow}
          formatSubtype={FormatSubType.Grid}
          href={constructUrl(item?.marketingUrl, getUrl)}
          index={index}
          location="program-carousel"
          name={item.title}
          pacing={item.pacing}
          totalPrice={total}
          priceWithoutDiscount={priceWithoutDiscount}
          type={item.type || ""}
          uuid={item.uuid}
          alignment={alignment}
          subjects={item?.subjects ?? []}
          partnerName={item.partners?.[0]?.name || ""}
        />
      );
    }

    if (cardType === "product-card") {
      return (
        <ProductCard
          name={item.title}
          href={constructUrl(item?.marketingUrl, getUrl)}
          imageUrl={
            item.cardImageUrl || "/product-cards/default-card-header-light.png"
          }
          type={item.type || "Course"}
          partnerFullName={item.partners?.[0]?.name || ""}
          partnerLogoUrl={
            item.partners?.[0]?.logoUrl ||
            "/trademark-logos/edx-logo-registered-elm.png"
          }
          location="program-carousel"
          index={index}
          subjects={item?.subjects ?? []}
          uuid={item.uuid}
          childCoursesCount={item.courses?.length || 0}
          weeksToComplete={item.weeksToComplete}
          pacing={
            (item.pacing as "self_paced" | "instructor_paced") ?? "self_paced"
          }
        />
      );
    }

    return (
      <NewProductCard
        item={item}
        index={index}
        getUrl={getUrl}
        skipViewEvent={skipViewEvent}
        skipClickEvent={skipClickEvent}
      />
    );
  };

  return <div className={className}>{renderCard()}</div>;
}

export default CardWrapper;
